<qt-dialog>
  @if (termSheetStep !== 'processing') {
    <div qtDialogTitle>{{ 'GNR_CREATE_LOAN' | translate }}</div>
  }

  <div qtDialogContent>
    <div class="create-participant">
      @if (termSheetStep !== 'processing') {
        @if (termSheetStep !== 'details') {
          <div class="create-participant__subtitle">
            {{ 'GNR_PARTICIPATIONS_CREATE_SUBTITLE' | translate }}
          </div>

          <div class="create-participant__section">
            <div class="create-participant__section-title">
              {{ 'GNR_DEAL_INFORMATION' | translate }}
            </div>
            <div class="create-participant__grid">
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                [class.mat-form-field-invalid]="
                  nameControl.invalid &&
                  (nameControl.touched || nameControl.dirty)
                ">
                <mat-label>{{ 'GNR_ITM_LOAN_NAME' | translate }}</mat-label>
                <input
                  matInput
                  [formControl]="nameControl"
                  data-testid="deal-add-name-input" />
                <mat-error [control]="nameControl"></mat-error>
              </mat-form-field>

              @if (!isLeadBank) {
                <mat-form-field
                  appearance="outline"
                  subscriptSizing="dynamic"
                  [class.mat-form-field-invalid]="
                    purchaseAmountControl.invalid &&
                    (purchaseAmountControl.touched ||
                      purchaseAmountControl.dirty)
                  ">
                  <mat-label>{{ 'GNR_PURCHASE_AMOUNT' | translate }}</mat-label>
                  <input
                    matInput
                    qtKeyboard
                    qtCurrencyControl
                    type="text"
                    [formControl]="purchaseAmountControl" />
                  <mat-error [control]="purchaseAmountControl"></mat-error>
                </mat-form-field>
              }

              <div class="create-participant__row">
                <mat-form-field
                  appearance="outline"
                  subscriptSizing="fixed"
                  [class.mat-form-field-invalid]="
                    productControl.invalid &&
                    (productControl.touched || productControl.dirty)
                  ">
                  <mat-label>{{
                    'FTR_BOOKING_SELECT_PROD' | translate
                  }}</mat-label>
                  <mat-select
                    [formControl]="productControl"
                    data-testid="deal-add-product-select">
                    @if (products$ | async; as products) {
                      @for (product of products; track product.id) {
                        <mat-option [value]="product.id">
                          {{ product.label | translate }}
                        </mat-option>
                      }
                    }
                  </mat-select>
                  <mat-error [control]="productControl"></mat-error>
                </mat-form-field>

                <mat-form-field
                  appearance="outline"
                  subscriptSizing="fixed"
                  [class.mat-form-field-invalid]="
                    industryControl.invalid &&
                    (industryControl.touched || industryControl.dirty)
                  ">
                  <mat-label>{{ 'GNR_INDUSTRY' | translate }}</mat-label>
                  <mat-select
                    [formControl]="industryControl"
                    data-testid="deal-add-industry-input">
                    @if (industries$ | async; as industries) {
                      @for (
                        indu of industries | sort: 'asc' : 'name';
                        track indu.name
                      ) {
                        <mat-option [value]="indu?.id">{{
                          indu?.name || indu?.description
                        }}</mat-option>
                      }
                    }
                  </mat-select>
                  <mat-error [control]="industryControl"></mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          @if (isLeadBank) {
            <div class="create-participant__section">
              <div class="create-participant__section-title">
                {{ 'GNR_TEMPLATES' | translate }}
              </div>
              <div class="create-participant__grid">
                <mat-form-field
                  appearance="outline"
                  subscriptSizing="fixed"
                  [class.mat-form-field-invalid]="
                    ndaWorkflowControl.invalid &&
                    (ndaWorkflowControl.touched || ndaWorkflowControl.dirty)
                  ">
                  <mat-label>{{ 'GNR_NDA_WORKFLOW' | translate }}</mat-label>
                  <mat-select [formControl]="ndaWorkflowControl">
                    @for (option of ndaWorkflowOptions; track option.value) {
                      <mat-option [value]="option.value">
                        {{ option.label | translate }}
                      </mat-option>
                    }
                  </mat-select>
                  <mat-error [control]="ndaWorkflowControl"></mat-error>
                </mat-form-field>
                @if (isPersonalWorkflowSelected()) {
                  <qt-template-selector
                    [templateType]="templateTypes.RTF"
                    [label]="'GNR_TEMPLATE'"
                    [required]="true"
                    [formControl]="ndaTemplateControl">
                  </qt-template-selector>
                }
                <mat-form-field appearance="outline" subscriptSizing="fixed">
                  <mat-label>Workflow template</mat-label>
                  <mat-select
                    multiple
                    [formControl]="workflowTemplateControl"
                    data-testid="deal-add-workflow-template-select">
                    @for (
                      group of workflowTemplateGroups$ | async;
                      track group.dealName
                    ) {
                      @if (group.workflows.length > 0) {
                        <mat-optgroup [label]="group.dealName || 'Other'">
                          @for (wf of group.workflows; track wf._id) {
                            <mat-option [value]="wf._id">{{
                              wf.name
                            }}</mat-option>
                          }
                        </mat-optgroup>
                      }
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!-- <div class="create-participant__section">
            <div class="create-participant__section-title">
              {{ 'GNR_INVESTMENT' | translate }}
            </div>
            <div
              class="investment-hint"
                style="
                  margin: 0 12px 12px;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                ">
              <mat-icon aria-hidden="true">info</mat-icon>
              <span>{{ 'GNR_PURCHASE_AMOUNT_HELPER' | translate }}</span>
            </div>
            <div class="create-participant__grid">
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                  [class.mat-form-field-invalid]="
                    originalAmountControl.invalid &&
                    (originalAmountControl.touched ||
                      originalAmountControl.dirty)
                  ">
                <mat-label>{{
                  'GNR_ITM_ORIG_LOAN_AMT' | translate
                }}</mat-label>
                <input
                  matInput
                  qtKeyboard
                  qtCurrencyControl
                  type="text"
                  [formControl]="originalAmountControl"
                  data-testid="deal-add-orig-ammount" />
                <mat-error [control]="originalAmountControl"></mat-error>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                  [class.mat-form-field-invalid]="
                    agentHoldControl.invalid &&
                    (agentHoldControl.touched || agentHoldControl.dirty)
                  ">
                <mat-label>{{ 'GNR_AGENT_HOLD_AMNT' | translate }}</mat-label>
                <input
                  matInput
                  qtKeyboard
                  qtCurrencyControl
                  type="text"
                  [formControl]="agentHoldControl"
                  data-testid="deal-add-agent-hold" />
                <mat-error [control]="agentHoldControl"></mat-error>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                  [class.mat-form-field-invalid]="
                    minHoldControl.invalid &&
                    (minHoldControl.touched || minHoldControl.dirty)
                  ">
                <mat-label>{{ 'GNR_MIN_HOLD_SIZE' | translate }}</mat-label>
                <input
                  matInput
                  qtKeyboard
                  qtCurrencyControl
                  type="text"
                  [formControl]="minHoldControl" />
                <mat-error [control]="minHoldControl"></mat-error>
              </mat-form-field>
            </div>
          </div> -->
          }

          @if (!isLeadBank) {
            <div class="create-participant__section">
              <div class="create-participant__section-title">
                {{ 'GNR_BANK_AND_CONTACT' | translate }}
              </div>
              <div class="create-participant__grid">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>{{ 'GNR_BANK_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    [formControl]="leadBankControl"
                    [matAutocomplete]="leadBankAuto" />
                  <mat-autocomplete
                    #leadBankAuto="matAutocomplete"
                    [displayWith]="displayLeadBank">
                    @for (
                      institution of filteredLeadBanks$ | async;
                      track institution.acnId || institution.name
                    ) {
                      <mat-option [value]="institution">
                        {{ institution?.name || institution?.email }}
                        @if (institution?.email) {
                          <span>({{ institution.email }})</span>
                        }
                      </mat-option>
                    }
                  </mat-autocomplete>
                  <mat-error [control]="leadBankControl"></mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>{{
                    'GNR_CONTACT_EMAIL_OPTIONAL' | translate
                  }}</mat-label>
                  <input
                    matInput
                    type="email"
                    [formControl]="leadBankEmailControl" />
                  <mat-error [control]="leadBankEmailControl"></mat-error>
                </mat-form-field>

                @if (leadBankValidationMessage | async; as msg) {
                  <div
                    class="validation-hint"
                    [class.validation-hint--info]="suggestedEmails.length > 0">
                    @if (suggestedEmails.length) {
                      <span class="validation-message">
                        {{ msg || ('GNR_SUGGESTIONS' | translate) }}:
                      </span>
                      @for (email of suggestedEmails; track email) {
                        <button
                          type="button"
                          class="email-chip email-chip--info"
                          (click)="applyEmailSuggestion(email)">
                          {{ email }}
                        </button>
                      }
                    } @else {
                      @if (correctedEmail) {
                        <span class="validation-message">
                          {{ msg || ('GNR_CORRECTED_EMAIL' | translate) }}:
                        </span>
                        <button
                          type="button"
                          class="email-chip email-chip--info"
                          (click)="applyEmailSuggestion(correctedEmail)">
                          {{ correctedEmail }}
                        </button>
                      } @else {
                        <span class="validation-message">{{ msg }}</span>
                      }
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (!isManualOnly) {
            <div class="create-participant__upload">
              <div class="create-participant__upload-divider">
                <span></span>
                <span class="create-participant__upload-label">{{
                  'GNR_AND' | translate | uppercase
                }}</span>
                <span></span>
              </div>
              <div class="create-participant__upload-header">
                <div class="create-participant__section-title">
                  {{ 'GNR_UPLOAD_TERM_SHEET' | translate }}
                </div>
                <div class="create-participant__upload-subtitle">
                  {{ 'GNR_UPLOAD_TERM_SHEET_HINT' | translate }}
                </div>
              </div>
              @let isTermSheetUploading = isTermSheetUploading$ | async;
              <div
                class="create-participant__dropzone"
                [class.dragging]="termSheetDragCounter > 0"
                [class.has-files]="termSheetFiles.length > 0"
                [class.uploading]="isTermSheetUploading"
                [class.disabled]="!canUploadTermSheet"
                [class.blocked]="termSheetUploadBlocked"
                [matTooltip]="
                  'GNR_FILL_REQUIRED_FIELDS_BEFORE_TERM_SHEET' | translate
                "
                [matTooltipDisabled]="canUploadTermSheet"
                (drop)="handleTermSheetDrop($event)"
                (dragover)="handleTermSheetDragOver($event)"
                (dragenter)="handleTermSheetDragEnter($event)"
                (dragleave)="handleTermSheetDragLeave($event)"
                (click)="openTermSheetFileSelector()">
                <input
                  #termSheetInput
                  type="file"
                  class="create-participant__file-input"
                  (change)="onTermSheetFileInputChange($event)"
                  accept=".pdf" />

                @if (!isTermSheetUploading) {
                  <div class="create-participant__dropzone-title">
                    <button
                      type="button"
                      class="create-participant__dropzone-link"
                      (click)="
                        $event.stopPropagation(); openTermSheetFileSelector()
                      ">
                      Choose a file
                    </button>
                    <span> or drag and drop here</span>
                  </div>
                  <div class="create-participant__dropzone-subtitle">
                    Size limit: 150MB
                  </div>
                }

                @if (termSheetFiles.length > 0) {
                  <div class="create-participant__file-list">
                    @for (file of termSheetFiles; track file) {
                      <div class="create-participant__file-item">
                        <span>{{ file.name }}</span>
                        <span>{{ file.size | filesize }}</span>
                        <button
                          mat-icon-button
                          type="button"
                          (click)="
                            $event.stopPropagation(); deleteTermSheetFile(file)
                          ">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    }
                  </div>
                }

                @if (termSheetUploadError) {
                  <div class="create-participant__upload-error">
                    {{ 'ERR_FILE_UPLOAD_ERR' | translate }}
                  </div>
                }
              </div>
            </div>

            <div class="create-participant__note message message-info">
              <mat-icon>info</mat-icon>
              <p>{{ 'GNR_VALUES_UPDATE_HINT' | translate }}</p>
            </div>
            @if (termSheetWrongDocument) {
              <div
                #termSheetErrorMessage
                class="create-participant__term-sheet-error message message-error">
                <mat-icon>error</mat-icon>
                <div class="message-error__content">
                  <div class="message-error__title">
                    {{ 'GNR_TERM_SHEET_INVALID_TITLE' | translate }}
                  </div>
                  <div class="message-error__body">
                    {{ 'GNR_TERM_SHEET_INVALID_BODY' | translate }}
                  </div>
                </div>
              </div>
            }
          }

          <div
            class="create-participant__section create-participant__section--no-divider">
            <div class="create-participant__grid">
              <qt-template-selector
                class="create-participant__template-selector"
                [templateType]="templateTypes.FOLDER"
                [label]="'GNR_FOLDER_TEMPLATE'"
                [required]="false"
                [formControl]="folderTemplateControl" />
            </div>
          </div>
        }

        @if (termSheetStep === 'details') {
          <div class="create-participant__details-layout">
            <div class="create-participant__details-form">
              <div class="create-participant__section">
                <div class="create-participant__section-title">
                  {{ 'GNR_LOAN_TERMS' | translate }}
                </div>
                <div
                  class="create-participant__grid create-participant__grid--two-column">
                  <mat-form-field appearance="outline" subscriptSizing="fixed">
                    <mat-label>{{
                      'FTR_BOOKING_SELECT_PROD' | translate
                    }}</mat-label>
                    <mat-select [formControl]="productControl">
                      @if (products$ | async; as products) {
                        @for (product of products; track product.id) {
                          <mat-option [value]="product.id">
                            {{ product.label | translate }}
                          </mat-option>
                        }
                      }
                    </mat-select>
                    <mat-error [control]="productControl"></mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" subscriptSizing="fixed">
                    <mat-label>{{ 'GNR_INDUSTRY' | translate }}</mat-label>
                    <mat-select [formControl]="industryControl">
                      @if (industries$ | async; as industries) {
                        @for (
                          indu of industries | sort: 'asc' : 'name';
                          track indu.name
                        ) {
                          <mat-option [value]="indu?.id">{{
                            indu?.name || indu?.description
                          }}</mat-option>
                        }
                      }
                    </mat-select>
                    <mat-error [control]="industryControl"></mat-error>
                  </mat-form-field>

                  <qt-date-hour-picker
                    class="create-participant__date-picker"
                    [formControl]="termSheetControls.closedDate"
                    [label]="'GNR_CLOSED_DT' | translate"
                    outputFormat="yyyy-MM-DD"></qt-date-hour-picker>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{ 'GNR_INT_RATE' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      qtPercentControl
                      [formControl]="termSheetControls.initialInterestRate" />
                    <span matTextSuffix>%</span>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{ 'GNR_ITM_PMT_FRQ' | translate }}</mat-label>
                    <mat-select
                      [formControl]="termSheetControls.paymentFrequency">
                      @for (
                        option of termSheetSelectOptions['paymentFrequency'] ??
                          [];
                        track option.id
                      ) {
                        <mat-option [value]="option.id">
                          {{
                            option.name ||
                              option.label ||
                              option.description ||
                              option.id
                          }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{ 'GNR_TERM' | translate }}</mat-label>
                    <input
                      matInput
                      type="number"
                      [formControl]="termSheetControls.term" />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_AMORTIZATION' | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="number"
                      [formControl]="termSheetControls.amortization" />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{ 'GNR_INDEX' | translate }}</mat-label>
                    <mat-select [formControl]="termSheetControls.index">
                      @for (
                        option of termSheetSelectOptions['index'] ?? [];
                        track option.id
                      ) {
                        <mat-option [value]="option.id">
                          {{
                            option.name ||
                              option.label ||
                              option.description ||
                              option.id
                          }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{ 'GNR_ITM_SPREAD' | translate }}</mat-label>
                    <input
                      matInput
                      type="text"
                      qtPercentControl
                      [formControl]="termSheetControls.spread" />
                    <span matTextSuffix>%</span>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_RESET_FREQ' | translate
                    }}</mat-label>
                    <mat-select
                      [formControl]="termSheetControls.rateResetFrequency">
                      @for (
                        option of termSheetSelectOptions[
                          'rateResetFrequency'
                        ] ?? [];
                        track option.id
                      ) {
                        <mat-option [value]="option.id">
                          {{
                            option.name ||
                              option.label ||
                              option.description ||
                              option.id
                          }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_ORIG_LOAN_AMT' | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="text"
                      qtCurrencyControl
                      [formControl]="termSheetControls.originalLoanAmount" />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_PRINCIPAL_BALANCE' | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="text"
                      qtCurrencyControl
                      [formControl]="termSheetControls.principalBalance" />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_PURCHASE_PRICE' | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="text"
                      qtPercentControl
                      [formControl]="termSheetControls.purchasePrice" />
                    <span matTextSuffix>%</span>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_SYNDIC_TYPE' | translate
                    }}</mat-label>
                    <mat-select
                      [formControl]="termSheetControls.syndicationType">
                      @for (
                        option of termSheetSelectOptions['syndicationType'] ??
                          [];
                        track option.id
                      ) {
                        <mat-option [value]="option.id">
                          {{
                            option.name ||
                              option.label ||
                              option.description ||
                              option.id
                          }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_UNDERW_TYPE' | translate
                    }}</mat-label>
                    <mat-select
                      [formControl]="termSheetControls.underwritingType">
                      @for (
                        option of termSheetSelectOptions['underwritingType'] ??
                          [];
                        track option.id
                      ) {
                        <mat-option [value]="option.id">
                          {{
                            option.name ||
                              option.label ||
                              option.description ||
                              option.id
                          }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="create-participant__section">
                <div class="create-participant__section-title">
                  {{ 'GNR_PROD_LINE' | translate }}
                </div>
                <div
                  class="create-participant__grid create-participant__grid--two-column">
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>LTV</mat-label>
                    <input
                      matInput
                      type="text"
                      qtPercentControl
                      [formControl]="termSheetControls.ltv" />
                    <span matTextSuffix>%</span>
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{ 'GNR_I_O_PERIOD' | translate }}</mat-label>
                    <input
                      matInput
                      type="number"
                      [formControl]="termSheetControls.interestOnlyPeriod" />
                  </mat-form-field>
                </div>
              </div>

              <div class="create-participant__section">
                <div class="create-participant__section-title">
                  {{ 'GNR_LENDERS' | translate }}
                </div>
                <div
                  class="create-participant__grid create-participant__grid--two-column">
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_AGT_HOLD_AMT' | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="text"
                      qtCurrencyControl
                      [formControl]="termSheetControls.agentBankHoldAmount" />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_AMT_FOR_PURCHASE' | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="text"
                      qtCurrencyControl
                      [formControl]="
                        termSheetControls.amountAvailableForPurchase
                      " />
                  </mat-form-field>

                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <mat-label>{{
                      'GNR_ITM_COM_SUB_RATE' | translate
                    }}</mat-label>
                    <input
                      matInput
                      type="text"
                      qtPercentControl
                      [formControl]="
                        termSheetControls.committedSubscriptionRate
                      " />
                    <span matTextSuffix>%</span>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="create-participant__details-preview">
              <button
                mat-icon-button
                type="button"
                class="create-participant__preview-open"
                [disabled]="!hasTermSheetPreview"
                [matTooltip]="'GNR_OPEN_NEW_TAB' | translate"
                (click)="openTermSheetPreview()">
                <mat-icon>open_in_new</mat-icon>
              </button>
              <div class="create-participant__preview-card">
                <div class="create-participant__preview-content">
                  <div
                    #termSheetPreviewContainer
                    class="create-participant__preview-canvas">
                    @if (termSheetPreviewLoading) {
                      <div class="create-participant__preview-loading">
                        <mat-spinner diameter="36"></mat-spinner>
                        <p>{{ 'GNR_PLS_WAIT' | translate }}</p>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      }

      @if (termSheetStep === 'processing') {
        <div class="create-participant__processing-overlay">
          <div class="create-participant__processing-card" role="status">
            <p class="create-participant__processing-title">
              {{ 'GNR_EXTRACTING_DOC_KEY_DETAILS' | translate }}
            </p>
            <p class="create-participant__processing-subtitle">
              {{ 'GNR_THIS_TAKE_FEW_SEC' | translate }}
            </p>
            <svg
              class="create-participant__processing-sparkles"
              viewBox="0 0 120 120"
              aria-hidden="true">
              <g class="sparkle sparkle--lg" transform="translate(60 62)">
                <g class="sparkle__inner">
                  <path
                    d="M0 -38 Q6 -8 27 0 Q6 8 0 38 Q-6 8 -27 0 Q-6 -8 0 -38 Z" />
                </g>
              </g>
              <g class="sparkle sparkle--md" transform="translate(98 30)">
                <g class="sparkle__inner">
                  <path
                    d="M0 -25 Q4 -5 18 0 Q4 5 0 25 Q-4 5 -18 0 Q-4 -5 0 -25 Z" />
                </g>
              </g>
              <g class="sparkle sparkle--sm" transform="translate(22 94)">
                <g class="sparkle__inner">
                  <path
                    d="M0 -18 Q3 -4 14 0 Q3 4 0 18 Q-3 4 -14 0 Q-3 -4 0 -18 Z" />
                </g>
              </g>
            </svg>
          </div>
        </div>
      }
    </div>
  </div>

  @if (termSheetStep !== 'processing') {
    <div qtDialogActions class="create-participant__actions">
      <button mat-button type="button" (click)="close()">
        {{ 'CMD_CLOSE' | translate }}
      </button>
      <button
        mat-flat-button
        color="accent"
        type="button"
        [disabled]="(saving$ | async) || (isTermSheetUploading$ | async)"
        (click)="submit()">
        {{ 'GNR_CREATE' | translate }}
      </button>
    </div>
  }
</qt-dialog>
